import React from 'react';

import { jobMap, swot } from '../content';
import { Panel } from './bits';

/* Deliverable 02 — the Job Map as a heatmap of stage averages (approaches ×
   stages), with the competitive position (formerly its own SWOT section)
   folded in directly beneath the grid. Per the 2026-08-04 review, nothing
   else renders below the heatmap: no click-detail, no synthesis paragraph —
   the grid, one legend line, then the two focus columns. */

function stageAverage(stage, colIndex) {
  const scores = stage.steps.map((s) => s.scores[colIndex]).filter((v) => v != null);
  if (!scores.length) return null;
  const avg = scores.reduce((a, b) => a + b, 0) / scores.length;
  return Math.round(avg * 10) / 10;
}

function heatClass(value) {
  if (value == null) return 'dp-heat-none';
  if (value <= 4) return 'dp-heat-lo';
  if (value <= 6) return 'dp-heat-mid';
  return 'dp-heat-hi';
}

export default function JobMapSection() {
  return (
    <section className="dp-section" id="job-map">
      <div className="dp-shell">
        <h2>{jobMap.title}</h2>
        <p className="dp-body">{jobMap.intro}</p>

        <Panel label={jobMap.label} kicker={jobMap.kicker} title={jobMap.job} meta={jobMap.meta}>
          <div className="dp-heat">
            <div className="dp-heat-row dp-heat-header">
              <span className="dp-heat-corner" />
              {jobMap.stages.map((s) => (
                <span key={s.stage} className="dp-heat-stage">
                  {s.stage}
                </span>
              ))}
            </div>
            {jobMap.columns.map((col, colIndex) => (
              <div key={col} className="dp-heat-row">
                <span className="dp-heat-approach">{col}</span>
                {jobMap.stages.map((stage) => {
                  const value = stageAverage(stage, colIndex);
                  return (
                    <span
                      key={stage.stage}
                      className={`dp-heat-cell ${heatClass(value)}`}
                      aria-label={`${col}, ${stage.stage}: ${value == null ? 'no evidence' : value}`}
                    >
                      {value == null ? '—' : value}
                    </span>
                  );
                })}
              </div>
            ))}
          </div>
          <p className="dp-legend">{jobMap.legend}</p>

          {/* Competitive position, derived from the map above */}
          <div className="dp-swot2">
            {swot.groups.map((group) => (
              <div key={group.key} className={`dp-swot2-col dp-swot2-${group.key}`}>
                <h4>{group.heading}</h4>
                {group.items.map((item) => (
                  <div
                    key={item.cite}
                    className={item.lead ? 'dp-swot2-item dp-swot2-lead' : 'dp-swot2-item'}
                  >
                    <p>
                      <span className={`dp-swot2-tag dp-swot2-tag-${item.tag}`}>{item.tag}</span>
                      {item.text}
                    </p>
                    <span className="dp-cite">{item.cite}</span>
                  </div>
                ))}
              </div>
            ))}
          </div>
        </Panel>
      </div>
    </section>
  );
}
